import { render, staticRenderFns } from "./FacebookFeed.vue?vue&type=template&id=7a8af857&scoped=true&"
import script from "./FacebookFeed.vue?vue&type=script&lang=js&"
export * from "./FacebookFeed.vue?vue&type=script&lang=js&"
import style0 from "./FacebookFeed.vue?vue&type=style&index=0&id=7a8af857&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8af857",
  null
  
)

export default component.exports